import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: {
        isOpen: false,
        statusCode: null,
        errorMessage: '',
        errorDetails: null,
    },
    loading: false,
    loadingCount: 0,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        showGlobalError: (state, action) => {
            const { statusCode, errorMessage, errorDetails } = action.payload;
            state.error = {
                isOpen: true,
                statusCode: statusCode || null,
                errorMessage: errorMessage || 'An unexpected error occurred',
                errorDetails: errorDetails || null,
            };
        },
        clearGlobalError: (state) => {
            state.error = {
                isOpen: false,
                statusCode: null,
                errorMessage: '',
                errorDetails: null,
            };
        },
        startLoading: (state) => {
            state.loadingCount += 1;
            state.loading = true;
        },
        stopLoading: (state) => {
            state.loadingCount = Math.max(0, state.loadingCount - 1);
            state.loading = state.loadingCount > 0;
        },
    },
});

export const { showGlobalError, clearGlobalError, startLoading, stopLoading } = uiSlice.actions;
export default uiSlice.reducer;
